import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Field } from '../_model/field';
import {Email} from '../_model/email';

const pathApi = 'Email';

@Injectable({
    providedIn: 'root',
})
export class EmailService {

    constructor(private http: HttpClient) { }

    enviar(codigoTemplate: string, fields: Field[]): Observable<any> {
        return this.http.post<any>(`${environment.URL_API}/${pathApi}/${codigoTemplate}`, fields);
    }

    enviarComEmpresa(codigoTemplate: string, idEmpresa: string, fields: Field[]): Observable<any> {
        return this.http.post<any>(`${environment.URL_API}/${pathApi}/${codigoTemplate}/${idEmpresa}`, fields);
    }

    send(email: Email): Observable<any> {
      return this.http.post<any>(`${environment.URL_API}/${pathApi}`, email);
    }
}
